import { render, staticRenderFns } from "./CodeigniterDevelopment.vue?vue&type=template&id=3bb9c843&"
import script from "./CodeigniterDevelopment.vue?vue&type=script&lang=js&"
export * from "./CodeigniterDevelopment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports